import PropTypes from 'prop-types';

import { evaluateCondition } from 'global/fieldValidationFunction';

export const InputFieldRenderGuard = ({ field, evaluateConditionOptions, children }) => {
  const { whenShouldFieldRender } = field;

  if (!evaluateCondition(whenShouldFieldRender, evaluateConditionOptions)) {
    return null;
  }

  return children;
};
InputFieldRenderGuard.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    whenShouldFieldRender: PropTypes.object,
    type: PropTypes.string,
    options: PropTypes.array,
    infoText: PropTypes.string,
    optional: PropTypes.any,
    readOnly: PropTypes.bool,
  }).isRequired,
  evaluateConditionOptions: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
